import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    setSubmitStatus('success');
    setIsSubmitting(false);
    setFormData({ name: '', email: '', subject: '', message: '' });
    
    // Reset status after 3 seconds
    setTimeout(() => setSubmitStatus(null), 3000);
  };

  return (
    <div className="page">
      <div className="container">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="page-header">
          <h1>Get in Touch</h1>
          <p>Have questions, suggestions, or just want to share your cooking journey? We'd love to hear from you!</p>
        </motion.div>

        <div className="grid grid-2">
          {/* Contact Form */}
          <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 }} className="card">
            <h2 style={{ marginTop: 0 }}>Send us a Message</h2>
            
            {submitStatus === 'success' && (
              <div className="alert success" style={{ marginBottom: 16 }}>
                Thank you for your message! We'll get back to you soon.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="grid" style={{ gridTemplateColumns: '1fr', gap: 16 }}>
                <div>
                  <label htmlFor="name" className="label">Name</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="input" placeholder="Your name" />
                </div>
                <div>
                  <label htmlFor="email" className="label">Email</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="input" placeholder="your@email.com" />
                </div>
              </div>

              <div style={{ marginTop: 16 }}>
                <label htmlFor="subject" className="label">Subject</label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="input" placeholder="What's this about?" />
              </div>

              <div style={{ marginTop: 16 }}>
                <label htmlFor="message" className="label">Message</label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required className="textarea" placeholder="Tell us more..." />
              </div>

              <button type="submit" disabled={isSubmitting} className="btn btn-green full-width" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 16 }} >
                {isSubmitting ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    Sending...
                  </>
                ) : (
                  <>
                    <FaPaperPlane />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.4 }}>
            <div className="card">
              <h2 style={{ marginTop: 0 }}>Contact Information</h2>
              
              <div className="info-list">
                <div className="info-item">
                  <div className="badge green"><FaEnvelope /></div>
                  <div>
                    <h3 style={{ margin: 0 }}>Email</h3>
                    <p style={{ margin: 0, color: '#6b7280' }}>heygouri79@gmail.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="badge blue"><FaPhone /></div>
                  <div>
                    <h3 style={{ margin: 0 }}>Phone</h3>
                    <p style={{ margin: 0, color: '#6b7280' }}>+91 7887483031</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="badge purple"><FaMapMarkerAlt /></div>
                  <div>
                    <h3 style={{ margin: 0 }}>Address</h3>
                    <p style={{ margin: 0, color: '#6b7280' }}>Bangalore, Karnataka, India</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card gradient-card">
              <h3 style={{ marginTop: 0 }}>Join Our Community</h3>
              <p>Connect with fellow food enthusiasts and stay updated with the latest recipes and nutrition tips.</p>
              <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                <button className="btn btn-primary">Follow Us</button>
                <button className="btn btn-outline" style={{ background: 'transparent', border: '2px solid #fff', color: '#fff' }}>Newsletter</button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
